import { HttpClient } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
    AuthService,
    base64ToBlob,
    BlockAbstractComponent,
    BlockDownloadPdfComponent,
    CacheService,
    ImageService,
    NodeType,
    PageService,
    ParserService,
    TrustService,
} from '@gallaghercp/core-frontend';
import { APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-block-downloads-bucket',
    templateUrl: './block-downloads-bucket.component.html',
    standalone: false,
})
export class BlockDownloadsBucketComponent extends BlockAbstractComponent implements OnInit {
    protected override parser: ParserService;
    protected override auth: AuthService;
    protected override pages: PageService;
    protected trust = inject(TrustService);
    protected cache = inject(CacheService);
    protected api = inject(HttpClient);
    protected modalService = inject(BsModalService);
    protected sanitiser = inject(DomSanitizer);
    protected imageService = inject(ImageService);

    downloadsTitle: string = '';
    downloads$?: Observable<any>;
    loading?: boolean;
    modalRef?: BsModalRef;
    directDownload: boolean = false;

    constructor() {
        const parser = inject(ParserService);
        const auth = inject(AuthService);
        const pages = inject(PageService);

        super(parser, auth, pages);

        this.parser = parser;
        this.auth = auth;
        this.pages = pages;
    }

    override ngOnInit() {
        super.ngOnInit();
        this.downloadsTitle = this.block.data.heading;
        if (this.block.nodes && this.block.nodes[0] && this.block.nodes[0].token) {
            this.downloads$ = this.cache.getOneThroughCache('node', this.block.nodes[0].token).pipe(
                map((node: { children: [] }) => {
                    return node.children
                        .filter((child: NodeType) => child.mime !== 'text/directory' && !child.hasChildren)
                        .map((child: NodeType) => {
                            // child.name = child.name.replace('.pdf', '.pdf');
                            return child;
                        });
                }),
            );
        }
    }

    downloadItem(token: string, name?: string) {
        this.loading = true;
        let options = {};
        if (!this.trust.isTrustModel) {
            options = { responseType: 'text' };
        }
        this.subscriptions.push(
            this.api
                .get('download/' + token + '?encoded=true', options)
                .pipe(
                    map((response: any) => {
                        return base64ToBlob(response, 'application/pdf');
                    }),
                )
                .subscribe((response: Blob) => {
                    this.modalRef = this.modalService.show(BlockDownloadPdfComponent, {
                        class: 'modal-lg modal-pdf',
                        initialState: {
                            blobUrl: URL.createObjectURL(response),
                            fileUrl: [APP_CONFIG.frontend, 'file', token].join('/'),
                            fileName: name,
                        },
                    });
                    this.loading = false;
                    return this.modalRef.content.onClose as Observable<boolean>;
                }),
        );
    }
}
